import { defineComponent as _defineComponent } from 'vue'
import {onMounted} from 'vue';
import config from '../config';
import {useRoute} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'GetCode',
  setup(__props, { expose }) {
  expose();

onMounted(() => {
    let {query} = useRoute();
    if (!query.code) {
        const redirectUri = encodeURIComponent(`${config.webHost}${window.location.pathname}`);
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.wechat.appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    }
});

const __returned__ = { onMounted, config, useRoute }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})